'use strict';
var ActionTypes = require('../constants/ActionTypes');

function app(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PROJECT_LOAD_DONE:
    return payload;
  default:
    return state || null;
  }
}

function current(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_LOAD_DONE:
    return payload;
  default:
    return state || null;
  }
}

function animation(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_REDIRECT_DONE:
    return payload.animation;
  case ActionTypes.PAGE_LOAD_DONE: // 如果是要求打开页面了, 那么动画应该置为空了
    return null;
  default:
    return state;
  }
}

function target(state, action) {
  var payload = action.payload;
  switch (action.type) {
  case ActionTypes.PAGE_REDIRECT_DONE:
    return payload.page;
  case ActionTypes.PAGE_LOAD_DONE: // 如果是要求打开页面了, 那么目标页面就应该置为空了
    return null;
  default:
    return state;
  }
}

function config(state, action) {
  return state;
}

module.exports = function (state, action) {
  return {
    app: app(state.app, action),
    current: current(state.current, action),
    target: target(state.target, action),
    animation: animation(state.animation, action),
    config: config(state.config, action)
  };
};



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js